import * as z from "zod";

const LatestValuesDtoSchema = z
    .object({
        value: z.string().trim(),
        timestamp: z.number(),
        tendency: z.number().nullable(),
    })
    .readonly();

export const LatestDataDtoSchema = z
    .record(z.string(), z.record(z.string(), LatestValuesDtoSchema).readonly())
    .superRefine((latestData) => Object.values(latestData).length === 1)
    .readonly();
export type LatestDataDto = z.output<typeof LatestDataDtoSchema>;
